export default function Contact() {
  return (
    <div className="container__policy">
      <h1>Contact Us</h1>
      <p>
        If you have any questions, suggestions, or feedback, feel free to reach out to us at{" "}
        <a href="mailto:forosho89@gmail.com">forosho89@gmail.com</a>
      </p>
    </div>
  );
}